// extracted by mini-css-extract-plugin
export default {"_":"balance____KaUey","text1":"balance_text1__cb7wm","text2":"balance_text2__kquDt"};